// LandingPage.js
import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import WhyPremium from '../components/why-premium/WhyPremium';

const WhyPremiumPage = () => {
  return (
    <div>
      <Header />
      <WhyPremium />
      <Footer />
    </div>
  );
};

export default WhyPremiumPage;
